import { msg } from '@lingui/core/macro';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchChampionship } from 'modules/championship/store/championship/actions';

import { allIdsChampionshipsDataSelector } from 'modules/championship/store/championship/selectors';
import { useDispatchWithToast } from 'store/use-dispatch-with-toast';
import { useChampionship } from './use-championship';

export const useChampionshipFetch = () => {
  const { id } = useParams<{ id: string }>();
  const dispatchWithToast = useDispatchWithToast();
  const { isLoading } = useChampionship(Number(id));
  const allLoadedChampionshipsIds = useSelector(allIdsChampionshipsDataSelector);
  const championshipId = id ? parseInt(id) : null;

  useEffect(() => {
    if (!isLoading && championshipId && !allLoadedChampionshipsIds.includes(championshipId)) {
      dispatchWithToast(fetchChampionship(championshipId), { error: msg`Не удалось загрузить турнир` });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [championshipId]);
};
